import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "assets-section" }
const _hoisted_2 = { class: "section-title" }
const _hoisted_3 = {
  key: 0,
  class: "battery-info"
}
const _hoisted_4 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_9 = { key: 0 }
const _hoisted_10 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_11 = {
  key: 0,
  class: "asset-details"
}
const _hoisted_12 = { class: "detail-row" }
const _hoisted_13 = { class: "label" }
const _hoisted_14 = { class: "value" }
const _hoisted_15 = { class: "detail-row" }
const _hoisted_16 = { class: "label" }
const _hoisted_17 = { class: "value" }
const _hoisted_18 = { class: "detail-row" }
const _hoisted_19 = { class: "label" }
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "detail-row" }
const _hoisted_22 = { class: "label" }
const _hoisted_23 = { class: "value" }
const _hoisted_24 = { class: "detail-row" }
const _hoisted_25 = { class: "label" }
const _hoisted_26 = { class: "value" }

import { ref } from 'vue'
import { useGolfVehiclesStore } from '@/store/golf-vehicles'


export default /*@__PURE__*/_defineComponent({
  __name: 'GolfCarAssetsSection',
  props: {
    profile: {}
  },
  setup(__props: any) {



const golfStore = useGolfVehiclesStore()

const assetDialogVisible = ref(false)
const selectedAsset = ref<any>(null)

const blockDialogVisible = ref(false)
const unblockDialogVisible = ref(false)
const blockComment = ref('')
const unblockComment = ref('')
const isBlocking = ref(false)
const isUnblocking = ref(false)

const getBatteryColor = (percentage: number) => {
  if (percentage <= 25) return '#F56C6C'
  if (percentage <= 50) return '#E6A23C'
  return '#67C23A'
}

const formatDate = (dateStr: string) => {
  if (!dateStr) return '—'
  return new Date(dateStr).toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  })
}

const isAssetBlocked = (asset: any) => {
  return asset.status === 'admin_blocked'
}

const viewAsset = (asset: any) => {
  selectedAsset.value = asset
  assetDialogVisible.value = true
}

const openBlockDialog = (asset: any) => {
  selectedAsset.value = asset
  blockComment.value = ''
  blockDialogVisible.value = true
}

const openUnblockDialog = (asset: any) => {
  selectedAsset.value = asset
  unblockComment.value = ''
  unblockDialogVisible.value = true
}

const confirmBlock = async () => {
  if (!blockComment.value.trim()) {
    return
  }
  isBlocking.value = true
  try {
    await golfStore.blockAsset(selectedAsset.value.id, {
      comment: blockComment.value,
    })
    blockDialogVisible.value = false
  } finally {
    isBlocking.value = false
  }
}

const confirmUnblock = async () => {
  isUnblocking.value = true
  try {
    await golfStore.unblockAsset(
      selectedAsset.value.id,
      unblockComment.value || undefined
    )
    unblockDialogVisible.value = false
  } finally {
    isUnblocking.value = false
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('golf.fleet.physical_assets')), 1),
    _createVNode(_component_el_table, {
      data: _ctx.profile.assets,
      stripe: "",
      style: {"width":"100%"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "id",
          label: "ID",
          "min-width": "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "stall_number",
          label: _ctx.$t('golf.trips.stall_number'),
          "min-width": "100"
        }, null, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('golf.fleet.battery'),
          "min-width": "120"
        }, {
          default: _withCtx(({ row }) => [
            (row.battery_pct !== null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createVNode(_component_el_progress, {
                    percentage: row.battery_pct,
                    color: getBatteryColor(row.battery_pct)
                  }, null, 8, ["percentage", "color"])
                ]))
              : (_openBlock(), _createElementBlock("span", _hoisted_4, "—"))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('golf.fleet.range_km'),
          "min-width": "120"
        }, {
          default: _withCtx(({ row }) => [
            (row.current_range_km !== null)
              ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(row.current_range_km), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_6, "—"))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('golf.fleet.wialon_unit_id'),
          "min-width": "150"
        }, {
          default: _withCtx(({ row }) => [
            (row.wialon_unit_id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(row.wialon_unit_id), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.$t('golf.common.not_configured')), 1))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('golf.fleet.last_telemetry'),
          "min-width": "180"
        }, {
          default: _withCtx(({ row }) => [
            (row.last_telemetry_at)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(formatDate(row.last_telemetry_at)), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_10, "—"))
          ]),
          _: 1
        }, 8, ["label"]),
        _createVNode(_component_el_table_column, {
          label: _ctx.$t('golf.fleet.actions'),
          "min-width": "200",
          fixed: "right"
        }, {
          default: _withCtx(({ row }) => [
            _createVNode(_component_el_button, {
              type: "primary",
              size: "small",
              onClick: ($event: any) => (viewAsset(row))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('golf.fleet.view')), 1)
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (!isAssetBlocked(row))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 0,
                  type: "warning",
                  size: "small",
                  onClick: ($event: any) => (openBlockDialog(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('golf.users.block')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  type: "success",
                  size: "small",
                  onClick: ($event: any) => (openUnblockDialog(row))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('golf.users.unblock')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(_component_el_dialog, {
      modelValue: assetDialogVisible.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((assetDialogVisible).value = $event)),
      title: _ctx.$t('golf.fleet.asset_dialog_title', { id: selectedAsset.value?.id }),
      width: "50%"
    }, {
      default: _withCtx(() => [
        (selectedAsset.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t('golf.trips.stall_number')) + ":", 1),
                _createElementVNode("span", _hoisted_14, _toDisplayString(selectedAsset.value.stall_number || '—'), 1)
              ]),
              _createElementVNode("div", _hoisted_15, [
                _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('golf.fleet.battery')) + ":", 1),
                _createElementVNode("span", _hoisted_17, _toDisplayString(selectedAsset.value.battery_pct) + "%", 1)
              ]),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.$t('golf.fleet.range')) + ":", 1),
                _createElementVNode("span", _hoisted_20, _toDisplayString(selectedAsset.value.current_range_km) + " km", 1)
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('golf.fleet.wialon_unit_id')) + ":", 1),
                _createElementVNode("span", _hoisted_23, _toDisplayString(selectedAsset.value.wialon_unit_id || '—'), 1)
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.$t('golf.fleet.last_telemetry')) + ":", 1),
                _createElementVNode("span", _hoisted_26, _toDisplayString(formatDate(selectedAsset.value.last_telemetry_at)), 1)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: blockDialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((blockDialogVisible).value = $event)),
      title: _ctx.$t('golf.users.block'),
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (blockDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "danger",
          onClick: confirmBlock,
          loading: isBlocking.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.users.block')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('golf.common.reason'),
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: blockComment.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((blockComment).value = $event)),
                  type: "textarea",
                  rows: 3,
                  placeholder: _ctx.$t('golf.common.reason')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: unblockDialogVisible.value,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((unblockDialogVisible).value = $event)),
      title: _ctx.$t('golf.users.unblock'),
      width: "400px"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[5] || (_cache[5] = ($event: any) => (unblockDialogVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.common.cancel')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "success",
          onClick: confirmUnblock,
          loading: isUnblocking.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('golf.users.unblock')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, { "label-width": "100px" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('golf.common.reason')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: unblockComment.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((unblockComment).value = $event)),
                  type: "textarea",
                  rows: 3,
                  placeholder: _ctx.$t('golf.common.reason')
                }, null, 8, ["modelValue", "placeholder"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ]))
}
}

})